import React, { useState, useEffect } from "react";
import "@ant-design/compatible/assets/index.css";
import {
    Row,
    Col,
    Table,
    Button,
    Tooltip,
    Spin,
    Popconfirm
} from "antd";
import {
    PicCenterOutlined,
    DeleteFilled,
    EditFilled,
    ArrowRightOutlined
} from "@ant-design/icons";
import { convertColumns } from "../../../utils/columnconverter";
import { notify } from "../../../redux/actions";
import { connect } from "react-redux";
import { aictia} from "../../../const/api"
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Individual(props) {
    let mainUrl =  'PacketOfPersonal'
    const [postlist, setPostList] = useState([]);
    const [spin, setSpin] = useState(false);
    const { t } = useTranslation();
    let [trigger, setTrigger] = useState(0);
    const cols = [
        { key: "tableIndex", value: "#", con: true },
        { key: "name", value: t("name"), con: true },
    ];

    const initialColumns = [
        {
            title: "#",
            dataIndex: "tableIndex",
            key: "1",
            width: 60,
        },
        {
            title: t("name"),
            dataIndex: "name",
            key: "2",
        },
        {
            title: "",
            dataIndex: "id",
            key: "",
            render: (i) => {
                console.log(i);
                return (
                    <div className="flex flex-end">
                        <Tooltip className="ml-5" title={t("edit")} placement="topRight">
                            <Link
                                to={{
                                    pathname: `/packet/edit/${i}`
                                }}
                            >
                                <Button className="border-none" type="text" shape="circle">
                                    <EditFilled />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Popconfirm
                            placement="topRight"
                            title={t("areYouSure")}
                            onConfirm={() => deletePost(i)}
                            okText={t("yes")}
                            cancelText={t("no")}
                        >
                            <Tooltip className="ml-5" title={t("delete")}>
                                <Button className="border-none" type="text" shape="circle">
                                    <DeleteFilled />
                                </Button>
                            </Tooltip>
                        </Popconfirm>

                        <Tooltip className="ml-5" title="Ətraflı" placement="topRight">
                            <Link
                                to={{
                                    pathname: `/packet/detail/${i}`
                                }}
                            >
                                <Button className="border-none" type="text" shape="circle">
                                     <ArrowRightOutlined />
                                </Button>
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];

    const { notify } = props;

    const deletePost = async (i) => {
        if (i === 0 || i) {
            await aictia
                .delete(`${mainUrl}/${i}`)
                .then((res) => {
                    setTrigger(++trigger);
                    notify("silindi", true);
                })
                .catch((res) => {
                    notify(res.err, false);
                });
        }
    };

    const getPostList = () => {
        setSpin(true);
        aictia.get(mainUrl).then((res) => {
            res.data && setSpin(false);
            console.log(res.data);
            setPostList(
                res.data.map((d, index) => {
                    return {
                        ...d,
                        key: index + 1,
                        index,
                        tableIndex: index + 1
                    };
                })
            );
        });
    };
    console.log(postlist);
    useEffect(() => {
        getPostList();
    }, [t, trigger]);
    return (
        <div>
            <Row gutter={[10, 10]}>
                <Col xs={24}>
                    <div className="border flex-between page-heading flex p-2 mt-0 bg-white">
                        <div className="page-name">
                            <PicCenterOutlined className="f-20 mr5-15" />
                            <span className="f-20 bold">Fərdi üzvlük</span>
                        </div>
                        <div>
                            <Link
                                to={{
                                    pathname: `packet/create`,
                                    state: { locales: null },
                                }}
                            >
                                <Button type={"primary"}>Əlavə et</Button>
                            </Link>
                        </div>
                    </div>
                </Col>

                <>
                    {spin ? (
                        <Col xs={24}>
                            <div className="flex animated fadeInUp bg-white all-center p-2">
                                <Spin size={"large"} />
                            </div>
                        </Col>
                    ) : (
                        <Col xs={24}>
                            <Table
                                size="small"
                                className="bg-white animated fadeIn"
                                columns={initialColumns}
                                dataSource={convertColumns(postlist, cols)}
                                pagination={{
                                    pageSize: 25,
                                    current_page: 1,
                                }}
                            />
                        </Col>
                    )}
                </>
            </Row>
        </div>
    );
}


export default connect(null, { notify })(Individual);